/**
 * Token getter for Auth0 - set by UserIdResolver.
 * Used by axiosActions to add Authorization header to API requests.
 */
let authTokenGetter = null;

export const setAuthTokenGetter = (getter) => {
    authTokenGetter = getter;
};

export const getAuthToken = async () => {
    if (authTokenGetter && typeof authTokenGetter === 'function') {
        try {
            return await authTokenGetter();
        } catch (e) {
            return null;
        }
    }
    return null;
};
